import { createContext } from 'react';

export interface GWPModalContextValue {
	titleId: string;
	descriptionId: string;
	registerTitle: (present: boolean) => void;
	registerDescription: (present: boolean) => void;
}

const GWPModalContext = createContext<GWPModalContextValue | null>(null);

export default GWPModalContext;
